import { useQuery } from '@tanstack/react-query';
import { useAuth, appSeatService } from '@aaas/shared';

/**
 * Fetches ALL seat assignments for an app by looping through pages.
 * Returns a Set<string> of assigned account_ids for O(1) lookup.
 */
export function useAllAppSeats(workspaceId: string | undefined, appId: string | null) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['all-app-seats', workspaceId, appId],
    queryFn: async (): Promise<Set<string>> => {
      if (!workspaceId || !appId || !user) {
        throw new Error('Workspace ID, app ID, and user required');
      }

      const idToken = await user.getIdToken();
      const allAccountIds: string[] = [];
      let page = 1;
      const pageSize = 100;

      while (true) {
        const response = await appSeatService.getAppSeats(workspaceId, appId, idToken, page, pageSize);
        for (const seat of response.seats) {
          allAccountIds.push(seat.account_id);
        }
        if (page >= response.pagination.total_pages) break;
        page++;
      }

      return new Set(allAccountIds);
    },
    enabled: !!workspaceId && !!appId && !!user,
  });
}
